<template>
  <div class="offline-warning-panel">
    <div class="offline-warning-panel-component hidden" @click="close">
      <div class="component-background" @click="close" />
      <slide-y-up-transition :duration="1000">
        <div v-show="show" class="wrapper" :class="$store.state.theme">
          <div class="is-flex">
            <!-- <button class="delete is-medium close" /> -->
            <p style="flex-shrink: 1; margin-right: 20px">
              <img src="/img/home2/no-wifi.svg" />
            </p>
            <p class="is-size-5" style="flex: 1">{{ $t("offline") }}</p>
          </div>
        </div>
      </slide-y-up-transition>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";

export default {
  name: "OfflineWarningPanel",
  components: {},
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    EventBus.$on("OFFLINE_WARNING", (state) => {
      if (state) {
        if (!this.show) this.show = true; // block duplicate events, e.g. on screen resize
      } else this.close();
    });
  },
  methods: {
    close() {
      this.show = false;
      var name = ".offline-warning-panel-component";
      this.hideComponent(name);
      //   setTimeout(() => this.hideComponent(name), 1000);
    },
  },
};
</script>

<style scoped>
.hidden {
  display: none;
}
.component-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 2;
}
.wrapper {
  position: absolute;
  top: 0px;
  width: 100vw;
  /* max-width: 700px; */
  color: white;
  /* backdrop-filter: blur(8px); */
  /* background-color: rgba(254, 60, 60, 0.65); */
  /* padding: 18px; */
  /* box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35); */
  z-index: 21;
  border-bottom-right-radius: 25px;
  border-bottom-left-radius: 25px;
  text-align: left;
}
.is-flex {
  backdrop-filter: blur(8px);
  background-color: rgba(254, 60, 60, 0.85);
  width: 100vw;
  max-width: 700px;
  margin: auto;
  padding: 18px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35);
  border-bottom-right-radius: 25px;
  border-bottom-left-radius: 25px;
}
img {
  height: 60px;
  width: 60px;
}
.close {
  position: absolute;
  right: 0;
  top: 56px;
  margin: 10px;
}
/* .close {
  position: absolute;
  right: 0;
  top: 0;
  padding: 10px;
  color: #f5d252;
  opacity: 0.3;
  text-shadow: 1px 0px 1px rgba(0, 0, 0, 0.3);
} */
</style>